export class NitroHUD {

	constructor() {

		const style = document.createElement( 'style' );
		style.textContent = `
			#nitro-hud {
				position: absolute;
				bottom: 24px;
				left: 50%;
				transform: translateX( -50% );
				width: 240px;
				height: 14px;
				border-radius: 8px;
				background: rgba(0,0,0,0.5);
				padding: 3px;
				box-sizing: border-box;
				backdrop-filter: blur(8px);
				-webkit-backdrop-filter: blur(8px);
				font: 600 13px -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
				user-select: none;
				pointer-events: none;
				z-index: 10;
				overflow: hidden;
			}
			#nitro-hud .fill {
				height: 100%;
				width: 100%;
				border-radius: 6px;
				background: linear-gradient( 90deg, #ff6a00 0%, #ff9a3c 50%, #ffd66e 100% );
				transform-origin: left center;
				transition: transform 80ms linear;
			}
			#nitro-hud.active {
				box-shadow: 0 0 18px rgba(255,140,40,0.6), 0 0 4px rgba(255,200,120,0.8);
				animation: nitro-pulse 0.6s ease-in-out infinite;
			}
			@keyframes nitro-pulse {
				0%, 100% { box-shadow: 0 0 14px rgba(255,140,40,0.55); }
				50% { box-shadow: 0 0 24px rgba(255,180,80,0.9); }
			}
		`;
		document.head.appendChild( style );

		const el = document.createElement( 'div' );
		el.id = 'nitro-hud';
		const fill = document.createElement( 'div' );
		fill.className = 'fill';
		el.appendChild( fill );
		document.body.appendChild( el );

		this.el = el;
		this.fill = fill;

	}

	update( vehicle ) {

		if ( ! vehicle ) return;

		const charge = Math.max( 0, Math.min( 1, vehicle.nitroCharge || 0 ) );
		this.fill.style.transform = `scaleX(${ charge })`;

		if ( vehicle.nitroActive ) {

			this.el.classList.add( 'active' );

		} else {

			this.el.classList.remove( 'active' );

		}

	}

}
